async function openInvoicePdf(invoiceId) {
    console.log("Opening PDF for invoice:", invoiceId);

    try {
      const url = `/api/invoice/view/${invoiceId}/`;

      console.log("Request URL:", url);

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
      });

      console.log("Response status:", response.status);
      console.log(
        "Content-Type:",
        response.headers.get("content-type")
      );

      if (!response.ok) {
        const errorText = await response.text();

        console.error("Backend error response:");
        console.error(errorText);

        throw new Error(
          `HTTP ${response.status} - Unable to load PDF`
        );
      }

      const blob = await response.blob();

      console.log("Blob received:", blob);
      console.log("Blob type:", blob.type);
      console.log("Blob size:", blob.size);

      const blobUrl = window.URL.createObjectURL(blob);

      console.log("Blob URL:", blobUrl);

      window.open(blobUrl, "_blank");

      console.log("PDF opened successfully");
    } catch (error) {
      console.error("FULL PDF ERROR:");
      console.error(error);

      alert(`Failed to open PDF: ${error.message}`);
    }
  }

export {
  openInvoicePdf,
};